export default __webpack_public_path__ + "static/FTRegolaNeue-Bold-88988b6e5b52bc74c9e75ef11b600bd2.woff2";